<template>
  <div class="basic-list">
    <div class="module" v-for="a in equipmentList" :key="a.enterpriseId">
      <div class="module-head">{{a.enterpriseName}}</div>
      <div class="basic">
        <div
          class="item"
          v-for="(item, index) in a.equipmentList"
          :key="index"
        >
          <div class="basic-name">
            <div class="line"></div>
            <div class="box">
              <span>{{ item.title }}</span>
              <div class="right-box"></div>
            </div>
          </div>
          <div class="list-wrap">
            <div
              @click="chooseBase(item)"
              class="list-equip water-equip"
              :class="{'more': obj.socketList.length > 4}"
              v-for="obj in item.sensorEquipments"
              :key="obj.id + 'sensor'"
            >
              <div class="water-title">
                <p>水质监控：</p>
                <h4
                  :class="{ waterOnline: obj.powerStatus == 1 }"
                  v-if="obj.powerStatus == 1"
                >
                  {{ obj.name }}
                </h4>
                <h4
                  :class="{
                    waterOffline: obj.powerStatus == 0 || obj.powerStatus == 2,
                  }"
                  v-else
                >
                  {{ obj.name }}
                </h4>
              </div>

              <div class="equip-params">
                <p>
                  <span v-for="(m, index) in obj.socketList" :key="index" class="equip-params-span">
                    {{ m.name }}:
                    <span class="current-value" :class="{ green: (m.lowerLimit < m.currentValue < m.upperLimit) && obj.powerStatus != 0, red: (m.currentValue < m.lowerLimit || m.currentValue > m.upperLimit) && obj.powerStatus != 0  }">{{ m.currentValue }} <font>{{ m.unitTitle }}</font> </span>
                  </span>
                </p>
              </div>
            </div>
            <div
              class="list-equip remote-equip"
              @click="chooseBase(item)"
              v-for="obj in item.switchEquipments"
              :class="{'more': obj.socketList.length > 4}"
              :key="obj.id + 'switch'"
            >
              <div class="remote-title">
                <p>远程控制：</p>
                <h4
                  :class="{ remoteOnline: obj.powerStatus == 1 }"
                  v-if="obj.powerStatus == 1"
                >
                  {{ obj.name }}
                </h4>
                <h4
                  :class="{
                    remoteOffline: obj.powerStatus == 0 || obj.powerStatus == 2,
                  }"
                  v-else
                >
                  {{ obj.name }}
                </h4>
              </div>
              <div class="equip-params">
                <p>
                  <span v-for="(m, index) in obj.socketList" :key="index" class="remote-params-span">
                    {{ m.name }}:
                    <span class="current-value">
                      (
                      <img
                        class="switch-img"
                        :src="
                          m.switchIsOpen
                            ? require('../../assets/images/lamp_open.png')
                            : require('../../assets/images/lamp_off.png')
                        "
                      /><span>
                        {{ m.switchIsOpen ? "开" : "关" }}</span
                      >
                      )</span
                    >
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

// 调整浏览器显示比例【仅能查看】
import equipmentV2 from '../../store/modules/equipmentV2'
import mixins from '@/assets/js/mixins.js'
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  name: 'BasicAllList',
  mixins: [mixins],
  data () {
    return {
      equipmentList: [],
      baseList: [],
      pondList: []
    }
  },
  watch: {},
  async mounted () {
    function pagePc () {
      let rootValue = 100
      let pc = rootValue / 1920 // 表示1366的设计图,使用100px的默认值
      let width = window.innerWidth // 当前窗口的宽度
      let height = window.innerHeight // 当前窗口的高度
      let rem = ''
      let currentHeight = (width * 798) / 1920
      if (height < currentHeight) {
      // 当前屏幕高度小于应有的屏幕高度，就需要根据当前屏幕高度重新计算屏幕宽度
        width = (height * 1920) / 798
      }
      rem = width * pc // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应font-size值
      document.documentElement.style.fontSize = rem + 'px'
    }

    pagePc()
    window.onresize = function () {
      pagePc()
    }
    this.setActiveTitle('')
    let list = await this.getEquipmentPlatformDataList()
    console.log(list)
    this.equipmentList = list
  },
  computed: {
    ...mapState(equipmentV2, ['currentEnterprise'])
  },
  methods: {
    ...mapActions(equipmentV2, ['getEquipmentPlatformDataList']),
    ...mapMutations(equipmentV2, ['setChooseBasic', 'setActiveTitle']),
    // 选择基地
    chooseBase (item) {
      localStorage.setItem('currentBasic', JSON.stringify(item))
      localStorage.setItem('currentEnterprise', this.currentEnterprise.id)
      this.setChooseBasic(item)
      this.getEquipmentData(item)
      this.$router.push({
        name: 'equipmentControl'
      })
    }
  }
}
</script>
<style lang="scss">
.waterOffline,
.remoteOffline {
  color: #828ca2;
}
.waterOnline {
  color: #87ee22;
}
.remoteOnline {
  color: #38e4fe;
}
.basic-list {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 64px);
  overflow-y: scroll;
  overflow-x: hidden;
  .module {
    .module-head {
      width: 100%;
      height: 0.64rem;
      background: rgba(0, 46, 115, 0.5);
      font-size: 0.24rem;
      font-family: Microsoft YaHei UI;
      font-weight: 400;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      padding-left: 0.27rem;
    }
  }
  .basic {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    padding-top: 0.2rem;
    .basic-name {
      width: 100%;
      // padding: 0 0.25rem;
      line-height: 0.85rem;
      font-size: 0.24rem;
      color: white;
      position: relative;
      // margin: 0 0.25rem;
      height: 0.45rem;
      line-height: 0.44rem;
      text-align: center;
      .line {
        width: 100%;
        height: 2px;
        background: linear-gradient(90deg, #148eff, #148EFF);
        position: absolute;
        bottom: 0;
        left: 0;
      }
      .box {
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        align-self: center;
        display: inline-block;
        transform:skewX(-25deg);
        height: 0.45rem;
        margin-right: 0.1rem;
        padding-right: 0.06rem;
        font-size: 0.18rem;
        color: #fefefe;
        border: 1px solid #148EFF;
        margin-left: 0.1rem;
        padding: 0 0.25rem;
        span {
          transform:skewX(25deg);
        }
        .right-box {
          width: 0.1rem;
          height: 0.45rem;
          border: 1px solid #148EFF;
          position: absolute;
          right: -0.1rem;
          top: -1px;
        }
      }
    }
    .list-wrap {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
    .item {
      width: 100%;
      padding: 0.05rem 0.25rem;
      cursor: pointer;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .list-equip {
      display: flex;
      width: 48%;
      // min-height: 100px;
      padding: 0.12rem 0px;
      margin-bottom: 0.2rem;
      flex-direction: column;
      > p {
        font-size: 0.22rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #777D8B;
      }
      .equip-params {
        // width: 68%;
        display: flex;
        // flex-direction: column;
        // justify-content: space-between;
        h4 {
          font-size: 0.18rem;
          color: #87ee22;
        }
        p {
          display: flex;
          font-size: 0.18rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #B7BCC6;
          // span {
          //   flex: 0 0 50%;
          // }
        }
      }

      &.more, &.more + .list-equip {
        width: 100%;
        flex-direction: row;
        align-items: baseline;
        .water-title, .remote-title {
          flex-shrink: 0;
          width: 3.18rem;
        }
        .equip-params {
          p {
            flex-wrap: wrap;
            .equip-params-span {
              margin-bottom: 0.12rem;
              // margin-right: 0.79rem;
              min-width: 2rem;
            }
          }
        }
      }
    }
    .water-equip,
    .remote-equip {
      // flex-direction: column;
      .water-title,
      .remote-title {
        display: flex;
        align-items: center;
        font-size: 0.22rem;
        p {
          color: #777d8b;
        }
      }
      .equip-params {
        font-size: 0.14rem;
        margin-top: 0.15rem;
        width: 100%;
      }
      .equip-params-span {
        margin-right: 0.3rem;
        &:last-child {
          margin-right: 0;
        }
      }
      .remote-params-span {
        margin-right: 0.3rem;
        &:last-child {
          margin-right: 0;
        }
      }
      .current-value {
        font-size: 0.22rem !important;
        .switch-img {
          width: 0.12rem;
          height: 0.13rem;
          margin: 0 0.15rem 0 0.1rem;
        }
        &.green {
          color: #00D53C;
        }
        &.red {
          color: #E92910;
        }
        font {
          font-size: 0.18rem;
        }
      }
    }
  }
}
</style>
